import React from "react"
import ContentLoader from "react-content-loader"

const MyLoader = (props) => (
    <div className="pt-4 mb-5 HomeLOad">
        <div className='container' style={{opacity:'.2'}}>
            <ContentLoader width={1600} height={600} speed={1} backgroundColor="#fff" foregroundColor="#999">
                <rect x="0" y="390" rx="10" ry="10" width="160" height="50" />
                <rect x="0" y="350" rx="10" ry="10" width="90" height="15" />
                <rect x="0" y="320" rx="10" ry="10" width="600" height="15" />
                <rect x="0" y="250" rx="30" ry="30" width="600" height="50" />
                <rect x="0" y="170" rx="30" ry="30" width="500" height="50" />
                <rect x="0" y="120" rx="10" ry="10" width="90" height="15" />
            </ContentLoader>
        </div>
    </div>
)

export default MyLoader